/*
  SarhSoft Cross-PlatForm Engine Project
  Lnaguages: PHP, JavaScript, Node, Java.
  BackEnd: Laravel.
  FrontEnd: Vue2.
  Project Type: (Laravel,Vue Mixin) Java Cross Frame.
  Written By: M.Farhat,
  Email: m.farhat@sarhsoft.com.
  Copyright © 2026 SarhSoft All rights reserved.
*/
import routes from '@routes/config';

export default [{
    path: routes.nationality.index,
    name: routes.nationality.index,
    component: () => import(/* webpackChunkName: "Nationality"*/  '@components/Nationality/Index')
}]
